import * as types from 'constants/actionTypes'
import * as _ from 'lodash'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {

    case types.RECEIVE_PLANS:
      return action.plans

    case types.UPDATE_PLAN:
      return {
        ...state,
        [action.id]: action.plan
      }

    case types.REMOVE_PLAN:
      const newState = { ...state }
      _.unset(newState, action.id)
      return newState

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/plans.js